import { render, staticRenderFns } from "./DocumentPrintPage.vue?vue&type=template&id=b837933e&scoped=true"
import script from "./DocumentPrintPage.vue?vue&type=script&lang=js"
export * from "./DocumentPrintPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintPage.vue?vue&type=style&index=0&id=b837933e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29._80ed213f6ba743306e514f7b7b6c1c5b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b837933e",
  null
  
)

export default component.exports